import React, { Component } from "react"
import Layout from "../components/layout"
import Highlight from "../components/highlight"
import "../css/blog.css"
import Link from "gatsby"

import SEO from "../components/seo"

function getFeaturedBlob (markdown) {
  // Gets first paragraph instance to serve as the description
  let expression = /<p>.+<\/p>/
  let firstP = stripMarkdown(expression.exec(markdown)[0])

  //stupid netlify cant access document server side. Try catch to the rescue!
  return firstP
}

function stripMarkdown (markdown) {
  try {
    let tmp = document.createElement("div")
    tmp.innerHTML = markdown

    return tmp.textContent
  } catch {
    return markdown
  }
}


function parseDate (dateString) {

  let date = new Date(dateString)

  let month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][date.getMonth()];

  return `${month} ${date.getDate()} ${date.getFullYear()}`
}

function readingTime(ev) {
  const wordsPerMinute = 200; // Average case.
  let result;

  let textLength = ev.split(" ").length; // Split by words
  if(textLength > 0){
    let value = Math.ceil(textLength / wordsPerMinute);
    result = `~${value} min read`;
  }

  return result
};

class Blog extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      latest: this.props.pageContext.posts[0].node,
      recent: this.props.pageContext.posts.slice(1, 5),
      posts: this.props.pageContext.posts.slice(5),
      search: "",
      fallbackImgURL: "https://staging.circadence.com/wp-content/uploads/2020/08/nesa-by-makers-BVr3XaBiWLU-unsplash-1-scaled.jpg"
    }

    this.handleSearchChanges = this.handleSearchChanges.bind(this)
  }

  handleSearchChanges (e) {
    this.setState({
      search: e.target.value
    })
  }

  render () {
    return (
      <Layout>    <SEO />
        <div id="blog-header" className="mainContainer gray">
          <div className="bh-image" style={{backgroundImage: (this.state.latest.featured_media ? `url(${this.state.latest.featured_media.source_url})` : `url(${this.state.fallbackImgURL})`)}}/>
          <div className="bh-text">
            <div className="post-flag">
              <h3>Latest Post</h3>
            </div>
            <h2 dangerouslySetInnerHTML={{__html: this.state.latest.title}}></h2>
            <p className="blog-date">{parseDate(this.state.latest.date)} | {readingTime(this.state.latest.content)}</p>
            <div className="latest-text" dangerouslySetInnerHTML={{__html: getFeaturedBlob(this.state.latest.content)}} />
            <a href={`/blog/${this.state.latest.slug}`} target="__blank"><button style={{marginTop: 30}} className="flat-button">Read More</button></a>
          </div>
        </div>
        <div className="mainContainer deep-blue">
          <div className="centeredContainer wrap" style={{maxWidth: "none"}}>
            <h3 style={{flexBasis: "100%", marginBottom: 30, color: "white"}}>Recent Posts</h3>
            <div className="recent-container">
              {this.state.recent.map((post) => {

                return (
                  <div className="recent-post wrap">
                    <div className="recent-img" style={{backgroundImage: (post.node.featured_media ? `url(${post.node.featured_media.source_url})` : `url(${this.state.fallbackImgURL})`)}}/>
                    <h4><a href={`/blog/${post.node.slug}`} target="__blank" dangerouslySetInnerHTML={{__html: post.node.title}}></a></h4>
                    <p className="blog-date">{parseDate(post.node.date)} | {readingTime(post.node.content)}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="mainContainer" style={{paddingTop: 0}}>
          <div className="bl-search">
            <div className="centeredContainer">
              <h3 style={{marginRight: 40}}>All Posts</h3>
              <input type="text" value={this.state.search} placeholder="Search for a post" onChange={this.handleSearchChanges}/>
            </div>
          </div>
          <div className="centeredContainer">
            <div className="all-posts">
              {this.state.posts.filter((post) => {
                post.node.title = post.node.title.replace("’", "'") // damn wordpress and those single right quote marks

                return stripMarkdown(post.node.title.toLowerCase()).includes(this.state.search.toLowerCase()) || stripMarkdown(post.node.content.toLowerCase()).includes(this.state.search.toLowerCase())
              }).map((post) => {
                return (
                  <a href={`/blog/${post.node.slug}`} target="__blank">
                    <div className="normal-post">
                      <Highlight id={post.node.id} search={this.state.search} content={stripMarkdown(post.node.title)} additional={stripMarkdown(post.node.content)}/>
                      <p className="blog-date">{parseDate(post.node.date)} | {readingTime(post.node.content)}</p>
                      <p style={{margin: 0, fontWeight: 400}} dangerouslySetInnerHTML={{__html: getFeaturedBlob(post.node.content)}}/>
                    </div>
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Blog;
